export const getGPLUPolicySummaryPropertyPaths = () => {
  return {
    packageCd: 'benefitPackagingDetail.packageCd',
    txCreateDate: 'transactionDetails.txCreateDate',
    termEffectiveDate: 'termDetails.termEffectiveDate',
    rateGuaranteeMonths: 'rateGuaranteeRenewalDetails.rateGuaranteeMonths',
    methodOfDelivery: 'methodOfDelivery',
    riskStateCd: 'riskStateCd',
    maturityAge: 'policyDetail.maturityAge',
    hasConversion: 'policyDetail.hasConversion',
    carrierName: 'priorCarrierDetails.carrierName',
    carrierPolicyNo: 'priorCarrierDetails.carrierPolicyNo',
    numberOfEligibleLives: 'eligibilityInfo.numberOfEligibleLives',
    doliMaturAge: 'policyDetail.doliMaturAge',
    sicCode: 'sicCode',
    sicDescription: 'sicDescription',
    quoteUWOffer: 'policyDetail.quoteUWOffer',
  };
};
